const getters = {
  setuserinfo: state => state.user.setuserinfo,
  terminal: state => state.app.terminal,
  appId: state => state.app.appId,
  isLogin: state => state.user.isLogin,
  token: state => state.user.token,
  info: state => state.user.info,
  name: state => state.user.name,
  headImg: state => state.user.headImg,
  language: state => state.user.language,
  languageOld: state => state.user.languageOld,
  subjectType: (state, getters) => state.user.subjectType,
  eztRegistration: state => state.user.eztRegistration,
  exhibitionId: state => state.user.exhibitionId,
  exhibitorId: state => state.user.exhibitorId,
  visitorId: state => state.user.visitorId,
  fromUrl: state => state.user.fromUrl,
  invitationSource: state => state.user.invitationSource,
  advertisingSharing: state => state.user.advertisingSharing,
  config: state => state.config.configSwitch,
  servicePhone: state => state.config.servicePhone,
  serviceEmail: state => state.config.serviceEmail,
  loginAccount: state => state.login.loginAccount,
  loginType: state => state.login.loginType,
  inviteType: state => state.user.inviteType,
  timIsLogin: state => state.timStore.timIsLogin,
  isSDKReady: state => state.timStore.isSDKReady,
  customerServiceInfo: state => state.timStore.customerServiceInfo,
  currentUserProfile: state => state.timStore.currentUserProfile,
  conversationList: state => state.timStore.conversationList,
  chatDialogVisible: state => state.timStore.chatDialogVisible,
  userInfo: state => state.timStore.userInfo,
  currentConversation: state => state.timStore.currentConversation,
  currentUnreadCount: state => state.timStore.currentConversation.unreadCount,

  currentMessageList: state => state.timStore.currentMessageList,
  isCompleted: state => state.timStore.isCompleted,
  mergerMessageList: state => state.timStore.mergerMessageList,
  isShowConversationList: state => state.timStore.isShowConversationList,

  currentConversationInfo: state => state.timStore.currentConversationInfo,

  imAccount: state => {
    if(state.user.info.userInfo) {
      return state.user.info.userInfo.imAccount
    } else {
      return {}
    }
  },
  headImage: state => {
    if(state.user.info.userInfo) {
      return state.user.info.userInfo.headImage
    } else {
      return ''
    }
  },
  showList: state => state.timStore.showList,
  isTIM: state => state.user.isTIM,
  // TIM相关
  toAccount: (state) => {
    if (!state.timStore.currentConversation || !state.timStore.currentConversation.conversationID) {
      return ''
    }
    switch (state.timStore.currentConversation.type) {
      case 'C2C':
        return state.timStore.currentConversation.conversationID.replace('C2C', '')
      default:
        return state.timStore.currentConversation.conversationID
    }
  },
  currentConversationType: (state) => {
    if (!state.timStore.currentConversation || !state.timStore.currentConversation.type) {
      return ''
    }
    return state.timStore.currentConversation.type
  },
  imgUrlList: (state) => {
    return state.timStore.currentMessageList
      .filter(message => message.type === window.$TIM_TYPES.MSG_IMAGE && !message.isRevoked) // 筛选出没有撤回并且类型是图片类型的消息
      .map(message => message.payload.imageInfoArray[0].url)
  },
  hidden(state) {
    // eslint-disable-next-line no-unused-vars
    const temp = state.timStore.currentTime
    if (typeof document.hasFocus !== 'function') {
      return document.hidden
    }
    return !document.hasFocus()
  }
}
export default getters
